import './button-filter-style.scss'

import classNames from 'classnames'
import React from 'react'

const Button = ({ onPress, name, slug, active, type, hash }) => {
  const classNameCategory = () => {
    if (slug) {
      switch (true) {
        case slug.startsWith('register'):
          return 'register'
        case slug.startsWith('intermediate'):
          return 'intermediate'
        case slug.startsWith('advanced'):
          return 'advanced'
        case slug.startsWith('beginner'):
          return 'beginner'
        default:
          break
      }
    }
  }
  const universityBtnClass = classNameCategory()
  const btnClass = classNames({
    'contianer-button-filter': true,
    'university-button-filter': type === 'university-levels',
    active,
  })

  return (
    <div
      className={`${btnClass} ${universityBtnClass}`}
      tabIndex={slug}
      onKeyDown={onPress}
      onClick={onPress}
      role="a"
      href={hash}
      id={`${name}-filter-button`}
    >
      <p className="textButton">{name}</p>
    </div>
  )
}

export default Button
